import {NavigationTabsModuleEntityViewModel} from "./navigation-tabs-module.entity.view-model";
import {NAVIGATION_TABS} from "../../navigation-tabs-module.consts";
import {GameCenterMatchTabModel} from "../tabs/game-center/game-center.match.tab-model";
import {GameCenterLineupsTabModel} from "../tabs/game-center/game-center.lineups.tab-model";
import type {NavigationTabsModuleTabModel} from "../tabs/navigation-tabs-module.tab-model";
import {override, computed} from 'mobx';
import {GameCenterStatsTabModel} from "../tabs/game-center/game-center.stats.tab-model";
import {GameCenterH2hTabModel} from "../tabs/game-center/game-center.h2h.tab-model";
import type {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import type {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import type {NavigationTabsModuleTerms} from "../../navigation-tabs-module.terms";
import {GameCenterTrendsTabModel} from "../tabs/game-center/game-center.trends.tab-model";
import type {AppTerms} from "../../../../core/app/app-terms";
import {LINEUPS_CONSTS} from "../../../../core/app/consts";
import {GameCenterOddsTabModel} from "../tabs/game-center/game-center.odds.tab-model";
import {GameCenterPropositionBetsTabModel} from "../tabs/game-center/game-center.proposition-bets.tab-model";
import {GameCenterNewsTabModel} from "../tabs/game-center/game-center.news.tab-model";
import {GameCenterPointByPointTabModel} from "../tabs/game-center/game-center.point-by-point.tab-model";

export class NavigationTabsModuleGameCenterViewModel extends NavigationTabsModuleEntityViewModel {
  terms: AppTerms;
  constructor(entity: EntityViewModel, currentLinkModel: BaseLinkModel, terms: NavigationTabsModuleTerms, currentIndex: Number) {
    super(entity, currentLinkModel, terms);

    this.currentIndex = currentIndex;
  }
  @override get tabs() {
    const matchTab = new GameCenterMatchTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.match, this.terms.GAME_NAVBAR_MATCH, this.entity, this.currentLinkModel, this.currentIndex);
    const lineupsTab = new GameCenterLineupsTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.lineups, this.lineupsTabName, this.entity, this.currentLinkModel, this.currentIndex);
    const statsTab = new GameCenterStatsTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.stats, this.terms.STATS, this.entity, this.currentLinkModel, this.currentIndex);
    const trendsTab = new GameCenterTrendsTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.trends, this.terms.WEB_TRENDS_TITLE, this.entity, this.currentLinkModel, this.currentIndex);
    const oddsTab = new GameCenterOddsTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.odds, this.terms.WEB_ODDS_TAB_GAME_PAGE, this.entity, this.currentLinkModel, this.currentIndex);
    const propositionBetsTab = new GameCenterPropositionBetsTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.propositionBets, this.terms.WEB_PROPS_FILTER_PROPS, this.entity, this.currentLinkModel, this.currentIndex);
    const pointByPointTab = new GameCenterPointByPointTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.pointByPoint, this.terms.WEB_PBP_TAB, this.entity, this.currentLinkModel, this.currentIndex);
    const h2hTab = new GameCenterH2hTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.h2h, this.terms.GAME_H2H_TERM_IN_TITLE, this.entity, this.currentLinkModel, this.currentIndex);
    const newsTab = new GameCenterNewsTabModel(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.news, this.terms.WEB_NEWS_TAB_NAME, this.entity, this.currentLinkModel, this.currentIndex);

    const tabs: Array<NavigationTabsModuleTabModel> = [matchTab, lineupsTab, statsTab, pointByPointTab, trendsTab, newsTab, oddsTab, propositionBetsTab, h2hTab];
    const filteredTabs: Array<NavigationTabsModuleTabModel> = tabs.filter(tab => tab.isVisible);

    return filteredTabs;
  }

  @computed get lineupsTabName(): String {
    let tabName: String = this.terms.LINEUPS_GAME_MAIN;
    const isBoxScores = LINEUPS_CONSTS.boxScoresSportTypes.includes(this.entity?.sport?.id);
    const hasProbableLineups: Boolean = this.entity?.homeCompetitor?.lineups?.isProbable && this.entity?.awayCompetitor?.lineups?.isProbable;
    if (hasProbableLineups) {
      tabName = this.terms.PROBABLE_LINEUPS_HEADER_MATCH_TEXT_ELEMENT;
    }
    else if (this.entity?.hasPreMatchInjuryReport) {
      tabName = this.terms.LINEUPS_MISSING;
    } else if (isBoxScores) {
      tabName = this.terms.WEB_BOXSCORE;
    }

    return tabName;
  }

  get useRouteProps(): Boolean {
    return true;
  }
}

